import { Route, Switch } from "wouter";
import DbtJobDetailPage from "./transformations/detail";
import TransformationsListPage from "./transformations/list";

/**
 * Transformations (UX-3, FR-62).
 *
 * Declared with `nest` in `App.tsx`, so this page owns `/transformations` and
 * `/transformations/:id`, exactly as `RunsPage` owns `/runs/:runId`. The shell
 * renders the page header for the route; the list and the detail own only what
 * sits below it.
 */
export default function TransformationsPage() {
  return (
    <Switch>
      <Route path="/:id">
        {(params) => <DbtJobDetailPage key={params.id} id={params.id as string} />}
      </Route>
      <Route path="/">
        <TransformationsListPage />
      </Route>
    </Switch>
  );
}
